var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankLite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66653 7.14073C1.66653 6.14392 2.06852 5.53302 2.90039 5.07007L6.32476 3.16437C8.11912 2.16579 9.0163 1.6665 9.99987 1.6665C10.9834 1.6665 11.8806 2.16579 13.675 3.16437L17.0993 5.07007C17.9312 5.53302 18.3332 6.14392 18.3332 7.14073C18.3332 7.41103 18.3332 7.54618 18.3037 7.65729C18.1486 8.24104 17.6196 8.33317 17.1088 8.33317H2.89094C2.38009 8.33317 1.85113 8.24104 1.69605 7.65729C1.66653 7.54618 1.66653 7.41103 1.66653 7.14073Z",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99645 5.83301H10.0039",
    stroke: "#3348FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33321 8.33301V15.4163M6.66654 8.33301V15.4163",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 8.33301V15.4163M16.6665 8.33301V15.4163",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 15.4165H4.16653C2.78582 15.4165 1.66653 16.5358 1.66653 17.9165C1.66653 18.1466 1.85308 18.3332 2.0832 18.3332H17.9165C18.1467 18.3332 18.3332 18.1466 18.3332 17.9165C18.3332 16.5358 17.2139 15.4165 15.8332 15.4165Z",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLite);
export default __webpack_public_path__ + "static/media/bank-lite.92cd864d928376317f8653e42aa11b29.svg";
export { ForwardRef as ReactComponent };